import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';

/**
 * This component returns the last step of the creation modal.
 * @returns {JSX.Element} The rendered component.
 */
export const LastCall = () => {
  return <Text element='p' textType={TextType.Paragraph} value={messages.modalContentMessage} />;
};
